import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { GUEST_LANGUAGE_CODES } from './constants/guestLanguages';

i18n
  .use(HttpApi) // fetches translation.json files from /public/locales/{lang}/translation.json
  .use(LanguageDetector) // adds language detector
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // Guest pages offer more languages than the dashboard (AppRouter keeps the dashboard in en/fr/es).
    supportedLngs: GUEST_LANGUAGE_CODES,
    fallbackLng: 'en',
    debug: false,
    load: 'languageOnly',
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
